import { getApiClient, refreshTokensManually, resetApiClient } from './client'

import { tokenStorage } from '@/lib/storage/tokenStorage'
import type {
  AuthResponse,
  AuthTokens,
  BackendUser,
  LoginCredentials,
} from '@/types/auth'

export const authApi = {
  login: async (credentials: LoginCredentials) => {
    const client = getApiClient()
    const response = await client.post<AuthResponse>('/auth/login', credentials)
    return response.data
  },
  logout: async () => {
    const client = getApiClient()
    try {
      await client.post('/auth/logout')
    } catch {
      // Swallow logout errors to allow UI flow to continue
    } finally {
      tokenStorage.clear()
      resetApiClient()
    }
  },
  me: async () => {
    const client = getApiClient()
    const response = await client.get<{ user: BackendUser }>('/auth/me')
    // Transform the user object to match expected format
    const user = response.data.user
    return {
      id: user.id,
      email: user.email,
      name: user.name,
      roles: [user.role],
      permissions: [],
    }
  },
  refresh: async (): Promise<AuthTokens | null> => {
    const tokens = await refreshTokensManually()
    if (!tokens) {
      resetApiClient()
    }
    return tokens
  },
}
